var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import Overlay from '../Overlay';
import colors from '../../themes/colors';
import BodyContent from './Layout/BodyContent';
import FooterContent from './Layout/FooterContent';
import HeaderContent from './Layout/HeaderContent';
var CardWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  border: 2px solid ", ";\n  background-color: ", ";\n  border-radius: 8px;\n  ", "\n\n  ", "\n"], ["\n  position: relative;\n  border: 2px solid ", ";\n  background-color: ", ";\n  border-radius: 8px;\n  ", "\n\n  ", "\n"])), colors.neutral20, colors.white, function (_a) {
    var clickable = _a.clickable;
    return clickable && 'cursor: pointer;';
}, function (_a) {
    var size = _a.size;
    switch (size) {
        case 'xsmall': {
            return 'width: 228px';
        }
        case 'small': {
            return 'width: 304px';
        }
        case 'medium': {
            return 'width: 472px';
        }
        case 'large': {
            return 'width: 662px';
        }
        case 'tile': {
            return 'width: 276px';
        }
        case 'tile2': {
            return 'width: 306px';
        }
        default: {
            break;
        }
    }
    return '';
});
var CustomCard = function (props) {
    var _a = props.size, size = _a === void 0 ? 'small' : _a, footerProps = props.footerProps, headerProps = props.headerProps, loading = props.loading, onClick = props.onClick;
    var isLoading = (size === 'tile2' || size === 'tile') && loading;
    var withOverlay = !isLoading && onClick && Boolean(!(footerProps === null || footerProps === void 0 ? void 0 : footerProps.actionButton) && !(headerProps === null || headerProps === void 0 ? void 0 : headerProps.actionButton));
    var onCardClick = function () {
        if (withOverlay)
            onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    return (_jsxs(CardWrapper, __assign({ onClick: onCardClick, size: size, clickable: withOverlay }, { children: [withOverlay && _jsx(Overlay, {}), _jsx(HeaderContent, __assign({}, props, { loading: isLoading })), _jsx(BodyContent, __assign({}, props, { loading: isLoading })), _jsx(FooterContent, __assign({}, props, { loading: isLoading }))] })));
};
export default CustomCard;
var templateObject_1;
